import {ProjectUserRolesType, SubProjectRolesType} from "../types";

class UserRoles {
    private _roles: SubProjectRolesType[] | undefined;
    private _is_admin: boolean | undefined;

    constructor(roles: ProjectUserRolesType) {
        this._roles = roles.subproject_roles
        this._is_admin = roles.is_super_admin
    }

    public get roles() {
        return this._roles
    }

    public set roles(roles) {
        this._roles = roles
    }

    public get isAdmin() {
        return !!this._is_admin
    }

    isGranted(role: string, subproject_id: number | undefined|string |null= undefined) {
        if (this.isAdmin) {
            return true
        }
        if (subproject_id) {//subproject specific role checking is being performed here

            const roles = this.roles?.filter(r => r.subproject_id === +subproject_id)?.[0]?.roles
            return roles?.includes(role);
        } else if (subproject_id === null || subproject_id === undefined) {// assumes it's a pattern search across all subprojects
            const rows = this.roles?.filter(r => r.roles.includes(role)).length
            return !!(rows && rows > 0)
        }
        return false
    }

    isGrantedAny(roles: string[], subproject_id: number | string | undefined=undefined) {

        if (this.isAdmin) {
            return true
        }

        let result = false;
        if (!this.roles) {
            return false;
        }
        if (subproject_id) {
            const r = this.roles?.filter(r => r.subproject_id === +subproject_id)?.[0]?.roles;
            if (r) {
                for (let j = 0; j < roles.length; j++) {

                    const exists = r.includes(roles[j]);
                    if (exists) {
                        result = true;
                        break;

                    }
                }
            }
        } else if (subproject_id === undefined || subproject_id === null) {

            for (let i = 0; i < this.roles.length; i++) {
                const r = this.roles[i].roles;
                for (let j = 0; j < roles.length; j++) {

                    const exists = r.includes(roles[j]);
                    if (exists) {
                        result = true;
                        break;

                    }
                }
                if (result) {
                    break;
                }
            }

        }
        return result

    }

    checkGrantedByPattern(pattern: string) {
        if (this.isAdmin) {
            return true
        }
        const regEx = new RegExp("^" + pattern);
        const rows = this.roles?.find(r => {
            return r.roles.find(role => regEx.test(role))
        });
        return (rows && Object.keys(rows).length > 0) || false

    }

}

export const Roles = {
    //dashboard roles
    DASHBOARD_PERFORMANCE: "MNG_ROLE_PERFORMANCE_DASHBOARD",
    DASHBOARD_PRODUCTION: "MNG_ROLE_PRODUCTION_DASHBOARD",
    DASHBOARD_EXECUTIVE: "MNG_ROLE_EXECUTIVE_DASHBOARD",
    DASHBOARD_PRECAUTION: "MNG_ROLE_PRECAUTION_DASHBOARD",

    //loadsheet view roles
    LOADSHEET_BUDGETING_FINANCE_VIEW: "MNG_ROLE_LOADSHEET_BUDGETING_FINANCE_VIEW",
    LOADSHEET_PLANNING_FINANCE_VIEW: "MNG_ROLE_LOADSHEET_PLANNING_FINANCE_VIEW",
    LOADSHEET_BUDGETING_PROCESS_VIEW: "MNG_ROLE_LOADSHEET_BUDGETING_PROCESS_VIEW",
    LOADSHEET_PLANNING_PROCESS_VIEW: "MNG_ROLE_LOADSHEET_PLANNING_PROCESS_VIEW",
    LOADSHEET_BUDGETING_ORE_BLEND_VIEW: "MNG_ROLE_LOADSHEET_BUDGETING_ORE_BLEND_VIEW",
    LOADSHEET_PLANNING_ORE_BLEND_VIEW: "MNG_ROLE_LOADSHEET_PLANNING_ORE_BLEND_VIEW",
    LOADSHEET_BUDGETING_GOLD_ASSAY_VIEW: "MNG_ROLE_LOADSHEET_BUDGETING_GOLD_ASSAY_VIEW",
    LOADSHEET_PLANNING_GOLD_ASSAY_VIEW: "MNG_ROLE_LOADSHEET_PLANNING_GOLD_ASSAY_VIEW",
    LOADSHEET_BUDGETING_GOLD_ROOM_VIEW: "MNG_ROLE_LOADSHEET_BUDGETING_GOLD_ROOM_VIEW",
    LOADSHEET_PLANNING_GOLD_ROOM_VIEW: "MNG_ROLE_LOADSHEET_PLANNING_GOLD_ROOM_VIEW",
    LOADSHEET_BUDGETING_MINING_VIEW: "MNG_ROLE_LOADSHEET_BUDGETING_MINING_VIEW",
    LOADSHEET_PLANNING_MINING_VIEW: "MNG_ROLE_LOADSHEET_PLANNING_MINING_VIEW",
    LOADSHEET_PLANNING_MINING_EQUIPEMENT_VIEW: "MNG_ROLE_LOADSHEET_PLANNING_MINING_EQUIPMENT_VIEW",
    LOADSHEET_PLANNING_MINING_EQUIPEMENT_SUBMIT: "MNG_ROLE_LOADSHEET_PLANNING_MINING_EQUIPMENT_SUBMIT",
    LOADSHEET_PLANNING_FINANCE_SUBMIT: "MNG_ROLE_LOADSHEET_PLANNING_FINANCE_SUBMIT",

    LOADSHEET_DOWNTIME_VIEW:"MNG_ROLE_LOADSHEET_DOWNTIME_VIEW",
    LOADSHEET_DOWNTIME_SUBMIT:"MNG_ROLE_LOADSHEET_DOWNTIME_SUBMIT",
    LOADSHEET_DOWNTIME_PROCESS_VIEW: 'MNG_ROLE_LOADSHEET_DOWNTIME_PROCESS_VIEW',
    LOADSHEET_DOWNTIME_PROCESS_SUBMIT: 'MNG_ROLE_LOADSHEET_DOWNTIME_PROCESS_SUBMIT',
    LOADSHEET_DOWNTIME_MINING_VIEW: 'MNG_ROLE_LOADSHEET_DOWNTIME_MINING_VIEW',
    LOADSHEET_DOWNTIME_MINING_SUBMIT: 'MNG_ROLE_LOADSHEET_DOWNTIME_MINING_SUBMIT',

    //loadsheet submit roles
    LOADSHEET_BUDGETING_FINANCE_SUBMIT: "MNG_ROLE_LOADSHEET_BUDGETING_FINANCE_SUBMIT",
    LOADSHEET_BUDGETING_MINING_SUBMIT: "MNG_ROLE_LOADSHEET_BUDGETING_MINING_SUBMIT",
    LOADSHEET_PLANNING_MINING_SUBMIT: "MNG_ROLE_LOADSHEET_PLANNING_MINING_SUBMIT",
    LOADSHEET_BUDGETING_PROCESS_SUBMIT: "MNG_ROLE_LOADSHEET_BUDGETING_PROCESS_SUBMIT",
    LOADSHEET_PLANNING_PROCESS_SUBMIT: "MNG_ROLE_LOADSHEET_PLANNING_PROCESS_SUBMIT",

    //reports page

    REPORTS: "MNG_ROLE_REPORTS",
    REPORT_DAILY_CREATE: "MNG_ROLE_REPORT_DAILY_CREATE",
    REPORT_DAILY_SUBMIT: "MNG_ROLE_REPORT_DAILY_SUBMIT",
    REPORT_EXECUTIVE_SUBMIT: "MNG_ROLE_REPORT_EXECUTIVE_SUBMIT",
    ROLE_REPORT_EXECUTIVE_CREATE: "MNG_ROLE_REPORT_EXECUTIVE_CREATE",
    REPORT_EXECUTIVE_VIEW: "MNG_ROLE_REPORT_EXECUTIVE_VIEW",
    DAILY_EXECUTIVE_REPORT: "MNG_ROLE_DAILY_EXECUTIVE_REPORT",
    REPORT_DAILY_VIEW: "MNG_ROLE_REPORT_DAILY_VIEW",
    //data entry
    DATA_ENTRY: "MNG_ROLE_DATA_ENTRY",
    //forms delete
    FORM_GOLD_ASSAY_DELETE: "MNG_ROLE_DATA_ENTRY_GOLD_ASSAY_DELETE",
    FORM_GOLD_ROOM_DELETE: "MNG_ROLE_DATA_ENTRY_GOLD_ROOM_DELETE",
    FORM_MILLING_DELETE: "MNG_ROLE_DATA_ENTRY_MILLING_DELETE",
    FORM_MINING_DELETE: "MNG_ROLE_DATA_ENTRY_MINING_DELETE",
    FORM_ORE_BLEND_DELETE: "MNG_ROLE_DATA_ENTRY_ORE_BLEND_DELETE",
    FORM_REAGENT_DELETE: "MNG_ROLE_DATA_ENTRY_REAGENT_DELETE",
    FORM_HSE_DELETE: "MNG_ROLE_DATA_ENTRY_HSE_DELETE",
    FORM_HSE_DAILY_DELETE: "MNG_ROLE_DATA_ENTRY_HSE_DAILY_DELETE",
    FORM_FINANCE_DELETE: "MNG_ROLE_DATA_ENTRY_FINANCE_DELETE",
    FORM_DOWNTIME_DELETE: "MNG_ROLE_DATA_ENTRY_DOWNTIME_DELETE",
    FORM_CRUSHING_DELETE: "MNG_ROLE_DATA_ENTRY_CRUSHING_DELETE",
    FORM_EXPLORATION_DELETE: "MNG_ROLE_DATA_ENTRY_EXPLORATION_DELETE",

    //forms view
    FORM_GOLD_ASSAY_VIEW: "MNG_ROLE_DATA_ENTRY_GOLD_ASSAY_VIEW",
    FORM_CRUSHING_VIEW: "MNG_ROLE_DATA_ENTRY_CRUSHING_VIEW",
    FORM_DOWNTIME_VIEW: "MNG_ROLE_DATA_ENTRY_DOWNTIME_VIEW",
    FORM_FINANCE_VIEW: "MNG_ROLE_DATA_ENTRY_FINANCE_VIEW",
    FORM_GOLD_ROOM_VIEW: "MNG_ROLE_DATA_ENTRY_GOLD_ROOM_VIEW",
    FORM_HSE_VIEW: "MNG_ROLE_DATA_ENTRY_HSE_VIEW",
    FORM_HSE_DAILY_VIEW: "MNG_ROLE_DATA_ENTRY_HSE_DAILY_VIEW",
    FORM_MILLING_VIEW: "MNG_ROLE_DATA_ENTRY_MILLING_VIEW",
    FORM_MINING_VIEW: "MNG_ROLE_DATA_ENTRY_MINING_VIEW",
    FORM_ORE_BLEND_VIEW: "MNG_ROLE_DATA_ENTRY_ORE_BLEND_VIEW",
    FORM_REAGENT_VIEW: "MNG_ROLE_DATA_ENTRY_REAGENT_VIEW",
    FORM_EXPLORATION_VIEW: "MNG_ROLE_DATA_ENTRY_EXPLORATION_VIEW",

    //forms edit
    FORM_GOLD_ASSAY_EDIT: "MNG_ROLE_DATA_ENTRY_GOLD_ASSAY_EDIT",
    FORM_CRUSHING_EDIT: "MNG_ROLE_DATA_ENTRY_CRUSHING_EDIT",
    FORM_DOWNTIME_EDIT: "MNG_ROLE_DATA_ENTRY_DOWNTIME_EDIT",
    FORM_FINANCE_EDIT: "MNG_ROLE_DATA_ENTRY_FINANCE_EDIT",
    FORM_GOLD_ROOM_EDIT: "MNG_ROLE_DATA_ENTRY_GOLD_ROOM_EDIT",
    FORM_HSE_EDIT: "MNG_ROLE_DATA_ENTRY_HSE_EDIT",
    FORM_HSE_DAILY_EDIT: "MNG_ROLE_DATA_ENTRY_HSE_DAILY_EDIT",
    FORM_MILLING_EDIT: "MNG_ROLE_DATA_ENTRY_MILLING_EDIT",
    FORM_MINING_EDIT: "MNG_ROLE_DATA_ENTRY_MINING_EDIT",
    FORM_ORE_BLEND_EDIT: "MNG_ROLE_DATA_ENTRY_ORE_BLEND_EDIT",
    FORM_REAGENT_EDIT: "MNG_ROLE_DATA_ENTRY_REAGENT_EDIT",
    FORM_EXPLORATION_EDIT: "MNG_ROLE_DATA_ENTRY_EXPLORATION_EDIT",

    //forms approve
    FORM_GOLD_ASSAY_APPROVE: "MNG_ROLE_DATA_ENTRY_GOLD_ASSAY_APPROVE",
    FORM_CRUSHING_APPROVE: "MNG_ROLE_DATA_ENTRY_CRUSHING_APPROVE",
    FORM_DOWNTIME_APPROVE: "MNG_ROLE_DATA_ENTRY_DOWNTIME_APPROVE",
    FORM_FINANCE_APPROVE: "MNG_ROLE_DATA_ENTRY_FINANCE_APPROVE",
    FORM_GOLD_ROOM_APPROVE: "MNG_ROLE_DATA_ENTRY_GOLD_ROOM_APPROVE",
    FORM_HSE_APPROVE: "MNG_ROLE_DATA_ENTRY_HSE_APPROVE",
    FORM_MILLING_APPROVE: "MNG_ROLE_DATA_ENTRY_MILLING_APPROVE",
    FORM_MINING_APPROVE: "MNG_ROLE_DATA_ENTRY_MINING_APPROVE",
    FORM_ORE_BLEND_APPROVE: "MNG_ROLE_DATA_ENTRY_ORE_BLEND_APPROVE",
    FORM_REAGENT_APPROVE: "MNG_ROLE_DATA_ENTRY_REAGENT_APPROVE",
    FORM_EXPLORATION_APPROVE: "MNG_ROLE_DATA_ENTRY_EXPLORATION_APPROVE",
    FORM_HSE_DAILY_APPROVE: "MNG_ROLE_DATA_ENTRY_HSE_DAILY_APPROVE",
}
export default UserRoles